import React from "react";
import { Grid } from "@mui/material";

const LayoutWrapper = ({ borderShadow, minHeight, children }) => {
  return (
    <div className="layout-right-container" style={{}}>
      <Grid
        container
        sx={{
          background: "white",
          padding: "2rem .8rem 0 .8rem",
          borderRadius: "5px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: minHeight ? minHeight : "calc(100vh - 80px) !important",
          ["@media (max-width:450px)"]: {
            // eslint-disable-line no-useless-computed-key
          },
        }}
      >
        {children}
      </Grid>
    </div>
  );
};

export default LayoutWrapper;
